export const DEAL_LA_SC_DEAL_PURPOSE_TABLE_LAYOUT = [
  {
    tableKey: "Deal Purpose",
    groupShellList: [
      {
        groupShellKey: null,
        shellList: [
          {
            shellKey: "Deal Purpose",
          },
        ],
      },
    ],
  },
];

export const DEAL_LA_SC_OTHER_FINANCIAL_TERMS_TABLE_LAYOUT = [
  {
    tableKey: "Other Financial Terms",
    groupShellSectionList: [
      {
        groupShellSectionKey: "Other Financial Terms",
        groupShellList: [
          {
            groupShellKey: "Other Financial Terms",
            subGroupShellList: [
              {
                subGroupShellKey: "Other Financial Terms",
                shellList: [
                  {
                    shellKey: "Other Financial Terms",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];

export const DEAL_LA_SC_ADDITIONAL_INFORMATION_TABLE_LAYOUT = [
  {
    tableKey: "Additional Information",
    groupShellList: [
      {
        groupShellKey: null,
        shellList: [
          {
            shellKey: "Additional Information",
          },
        ],
      },
    ],
  },
];

export const DEAL_LA_SC_PARTNER_AXIS_TABLE_LAYOUT = [
  {
    tableKey: "Partner A Axis",
    groupShellSectionList: [
      {
        groupShellSectionKey: "Partner A Axis Section",
        groupShellList: [
          {
            groupShellKey: "Partner A Axis",
            subGroupShellList: [
              {
                subGroupShellKey: "Partner A",
                shellList: [
                  {
                    shellKey: "Partner A Name",
                  },
                  {
                    shellKey: "Partner A Relationship Context",
                  },
                ],
              },
              {
                subGroupShellKey: "Partner A Responsibility & Rights",
                shellList: [
                  {
                    shellKey: "Partner A Responsibility & Rights",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    tableKey: "Partner B Axis",
    groupShellSectionList: [
      {
        groupShellSectionKey: "Partner B Axis Section",
        groupShellList: [
          {
            groupShellKey: "Partner B Axis",
            subGroupShellList: [
              {
                subGroupShellKey: "Partner B",
                shellList: [
                  {
                    shellKey: "Partner B Name",
                  },
                  {
                    shellKey: "Partner B Relationship Context",
                  },
                ],
              },
              {
                subGroupShellKey: "Partner B Responsibility & Rights",
                shellList: [
                  {
                    shellKey: "Partner B Responsibility & Rights",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    tableKey: "Partner C Axis",
    groupShellSectionList: [
      {
        groupShellSectionKey: "Partner C Axis Section",
        groupShellList: [
          {
            groupShellKey: "Partner C Axis",
            subGroupShellList: [
              {
                subGroupShellKey: "Partner C",
                shellList: [
                  {
                    shellKey: "Partner C Name",
                  },
                  {
                    shellKey: "Partner C Relationship Context",
                  },
                ],
              },
              {
                subGroupShellKey: "Partner C Responsibility & Rights",
                shellList: [
                  {
                    shellKey: "Partner C Responsibility & Rights",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];

export const DEAL_LA_SC_FINANCIAL_TERMS_TABLE_LAYOUT = [
  {
    tableKey: "Main Financial Terms Table",
    groupShellSectionList: [
      {
        groupShellSectionKey: "Main Financial Terms Table",
        groupShellList: [
          {
            groupShellKey: "Main Financial Terms",
            subGroupShellList: [
              {
                subGroupShellKey: "Partner Axis",
                shellList: [
                  {
                    shellKey: "Paying Partner Axis(LA&SC)",
                  },
                  {
                    shellKey: "DISPLAY_RIGHT_ARROW",
                  },
                  {
                    shellKey: "Receiving Partner Axis(LA&SC)",
                  },
                ],
              },
              {
                subGroupShellKey: "Upfront",
                shellList: [
                  {
                    shellKey: "Upfront Payment(LA&SC)",
                  },
                ],
              },
              {
                subGroupShellKey: "Milestone Payment And Detail",
                shellList: [
                  {
                    shellKey: "Milestone Payment(LA&SC)",
                  },
                  {
                    shellKey: "Milestone Payment Detail(LA&SC)",
                  },
                ],
              },
              {
                subGroupShellKey: "Other Payment And Detail",
                shellList: [
                  {
                    shellKey: "Other Payment(LA&SC)",
                  },
                  {
                    shellKey: "Other Payment Detail(LA&SC)",
                  },
                ],
              },
              {
                subGroupShellKey: "Royalty(LA&SC)",
                shellList: [
                  {
                    shellKey: "Royalty Rate",
                  },
                  {
                    shellKey: "Royalty Detail",
                  },
                ],
              },
              {
                subGroupShellKey: "Total Payment",
                shellList: [
                  {
                    shellKey: "Total Payment(LA&SC)",
                  },
                  {
                    shellKey: "Disclosed Payment Sum(LA&SC)",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];

export const DEAL_LA_SC_ADVISOR_TABLE_LAYOUT = [
  {
    tableKey: "Advisor Table",
    groupShellSectionList: [
      {
        groupShellSectionKey: "Advisor Table",
        groupShellList: [
          {
            groupShellKey: "Advisor",
            subGroupShellList: [
              {
                subGroupShellKey: "Advisor",
                shellList: [
                  {
                    shellKey: "Advisor Name",
                  },
                  {
                    shellKey: "Party Axis",
                  },
                  {
                    shellKey: "Advisor Role",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];

export const DEAL_LA_SC_RIGHTS_SCOPE_TABLE_LAYOUT = [
  {
    tableKey: "Rights Scope Table",
    groupShellSectionList: [
      {
        groupShellSectionKey: "Rights Scope Section",
        groupShellList: [
          {
            groupShellKey: "Rights Scope Row",
            subGroupShellList: [
              {
                subGroupShellKey: "Rights Scope",
                shellList: [
                  {
                    shellKey: "Asset",
                  },
                  {
                    shellKey: "Rights Scope Type",
                  },
                  {
                    shellKey: "Rights Scope",
                  },
                  {
                    shellKey: "Contributing Axis",
                  },
                  {
                    shellKey: "Axis Direction",
                  },
                  {
                    shellKey: "Benefiting Axis",
                  },
                  {
                    shellKey: "Rights Limitation",
                  },
                  {
                    shellKey: "Intended Use",
                  },
                  {
                    shellKey: "Exclusivity",
                  },
                  {
                    shellKey: "Territory",
                  },
                  {
                    shellKey: "Territory Include",
                  },
                  {
                    shellKey: "Territory Exclude",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];
